import styled from 'styled-components';

export const LinkWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  padding: 20px 0 0 0;
`;

export const ButtonContainer = styled.div<{
  isMobile: boolean;
}>`
  width: 280px;
  ${(props) =>
    props.isMobile ? `position: relative; margin-top: 16px;` : `bottom: 30px;`}
  display: flex;
  flex-direction: 'column';
  margin-top: 20px;
  gap: 12px;
`;

export const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DividerWrapper = styled.div`
  margin: 30px 0px;
`;

export const DividerContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 3fr;
`;

export const CreateAccountButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonText = styled.span`
  margin-right: 10px;
`;
